import { render, staticRenderFns } from "./ContactsTable.vue?vue&type=template&id=1afbb090&scoped=true"
import script from "./ContactsTable.vue?vue&type=script&lang=js"
export * from "./ContactsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afbb090",
  null
  
)

export default component.exports